import { InstrumentInitialValuesDto } from '@app/shared/models/contracts/project-dto';

export const isInstrumentOwnerAmountEntered = (instrument: InstrumentInitialValuesDto) =>
  instrument.ownership
    ? Object.values(instrument.ownership).some((owner) => Boolean(owner?.amount))
    : false;
